export default __webpack_public_path__ + "static/media/SelectDestinationCentroHistorico.f7f5e394.svg";